import React from 'react';
import { Link } from 'react-router-dom';

const offices = ['New York', 'London', 'Lisbon', 'Bangalore', 'Pune', 'Manila', 'Santo Domingo'];
const LOGO_URL = '/assets/evolvebpm-logo.png';

export default function Footer() {
  return (
    <footer className="bg-[#0F1C40] text-[#F1EDE4] border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid md:grid-cols-12 gap-8">
          <div className="md:col-span-5">
            <div className="bg-white rounded-xl px-6 py-4 inline-block mb-6 shadow-lg">
              <img src={LOGO_URL} alt="EvolveBPM" className="h-14 w-auto" />
            </div>
            <p className="text-neutral-500 text-sm max-w-sm leading-relaxed">
              Built for B2B. Powered by AI. From awareness to BANT, under one roof.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] font-mono uppercase tracking-widest text-neutral-500 mb-4">Explore</div>
            <ul className="space-y-2 text-sm">
              <li><a className="hover:text-[#4ECDC4] transition" href="#capabilities">Capabilities</a></li>
              <li><a className="hover:text-[#4ECDC4] transition" href="#data-coverage">Data Coverage</a></li>
              <li><a className="hover:text-[#4ECDC4] transition" href="#abm-solutions">ABM Solutions</a></li>
              <li><a className="hover:text-[#4ECDC4] transition" href="#case-studies">Case Studies</a></li>
              <li><Link className="hover:text-[#4ECDC4] transition" to="/predictor">Predictor.com</Link></li>
              <li><Link className="hover:text-[#4ECDC4] transition" to="/privacy">Privacy Policy</Link></li>
              <li><a className="hover:text-[#4ECDC4] transition" href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[10px] font-mono uppercase tracking-widest text-neutral-500 mb-4">Global offices</div>
            <div className="flex flex-wrap gap-x-4 gap-y-2">
              {offices.map((o) => (
                <span key={o} className="text-sm text-neutral-300">{o}</span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-neutral-500">
          <div>© 2026 EvolveBPM. All rights reserved. <span className="text-neutral-600 ml-2 italic">Decoding the sales ecosystem.</span></div>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="hover:text-[#F1EDE4]">Privacy</Link>
            <Link to="/privacy" className="hover:text-[#F1EDE4]">Terms</Link>
            <span className="font-mono">v.2026.01</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
